import { all, call, fork, put, takeLeading } from "redux-saga/effects";
import { Action, companyInformationActions } from "./company-information-store";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { CustomerService } from "src/backend/openapi/v1";
import { applicationActions as applicationWrapperActions } from "src/components/application-store";

export function* putCustomerRequest(action: ReturnType<typeof companyInformationActions.putCustomerRequest>) {
  try {
    yield call(CustomerService.putApiV1Customer, action.payload.customerId, action.payload.data);
    yield put(companyInformationActions.setEditCustomerDialogProps(undefined));
    yield put(applicationWrapperActions.getCustomerRequestById(action.payload.customerId));
  } catch (error) {
    yield put(errorActions.addError(error));
  }
}

export function* watchPutCustomerRequest() {
  yield takeLeading(Action.PutCustomerRequest, putCustomerRequest);
}

export function* companyInformationSaga() {
  yield all([fork(watchPutCustomerRequest)]);
}
